import React from "react";
import { FaCheckCircle } from "react-icons/fa";

export default function ProcessSteps() {
  const steps = [
    {
      number: "1",
      title: "AI Content Planning",
      text: "Generate your personalized blog strategy",
    },
    {
      number: "2",
      title: "Smart Optimization",
      text: "Review and refine your content plan",
    },
    {
      number: "3",
      title: "Automated Creation",
      text: "Receive SEO-optimized content daily",
    },
    {
      number: "4",
      title: "Seamless Publishing",
      text: "Let our system handle distribution",
    },
  ];

  return (
    <section className="relative py-24 bg-slate-900 overflow-hidden">
      {/* Background gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-slate-900/95 to-slate-900/90" />

      <div className="container relative mx-auto px-4 max-w-6xl">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-white mb-16">
          How we make{" "}
          <span className="relative">
            <span className="absolute -inset-1 rounded-lg bg-gradient-to-r from-orange-500/20 to-rose-500/20 blur-sm animate-glow" />
            <span className="relative bg-gradient-to-r from-orange-500 to-rose-500 bg-clip-text text-transparent">
              content magic
            </span>
          </span>{" "}
          happen
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Connector lines for desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-orange-500/20 via-rose-500/20 to-orange-500/20 transform -translate-y-1/2" />

          {steps.map((step, index) => (
            <div key={index} className="w-full h-full">
              {/* Card */}
              <div className="w-full h-full bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700/50 transition-all duration-300 hover:border-orange-500/50 hover:shadow-lg hover:shadow-orange-500/10 group-hover:translate-y-[-4px]">
                {/* Number and check badge inline */}
                <div className="flex items-center space-x-2 mb-6">
                  <span className="text-4xl font-bold bg-gradient-to-r from-orange-500 to-rose-500 bg-clip-text text-transparent">
                    {step.number}
                  </span>
                  <FaCheckCircle className="text-orange-400 group-hover:text-rose-400 transition-colors duration-300" size={24} />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-semibold text-white mb-3 group-hover:text-orange-400 transition-colors duration-300">
                  {step.title}
                </h3>
                <p className="text-slate-300 leading-relaxed">{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
